export const REDUCER_NAME = "home";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOME = `${REDUCER_NAME}/SET_HOME`;

export const MATCH_CENTRE_HOME_PAGE_URL = "/";
export const DEFAULT_COMPETITION_ID = 58539;
